"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellPropertiesVerticalAlignmentDescriptor = exports.TableCellPropertiesTextDirectionDescriptor = exports.TableCellPropertiesShadingInfoDescriptor = exports.TableCellPropertiesNoWrapDescriptor = exports.TableCellPropertiesHideCellMarkDescriptor = exports.TableCellPropertiesFitTextDescriptor = exports.TableCellPropertiesLeftMarginDescriptor = exports.TableCellPropertiesBottomMarginDescriptor = exports.TableCellPropertiesRightMarginDescriptor = exports.TableCellPropertiesTopMarginDescriptor = exports.TableCellPropertiesTopRightDiagonalBorderDescriptor = exports.TableCellPropertiesTopLeftDiagonalBorderDescriptor = exports.TableCellPropertiesLeftBorderDescriptor = exports.TableCellPropertiesBottomBorderDescriptor = exports.TableCellPropertiesRightBorderDescriptor = exports.TableCellPropertiesTopBorderDescriptor = void 0;
var table_cell_properties_1 = require("./table-cell-properties");
var TableCellPropertiesTopBorderDescriptor = (function () {
    function TableCellPropertiesTopBorderDescriptor() {
    }
    TableCellPropertiesTopBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.topBorder = newValue;
    };
    TableCellPropertiesTopBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.topBorder;
    };
    TableCellPropertiesTopBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseTopBorder;
    };
    return TableCellPropertiesTopBorderDescriptor;
}());
exports.TableCellPropertiesTopBorderDescriptor = TableCellPropertiesTopBorderDescriptor;
var TableCellPropertiesRightBorderDescriptor = (function () {
    function TableCellPropertiesRightBorderDescriptor() {
    }
    TableCellPropertiesRightBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.rightBorder = newValue;
    };
    TableCellPropertiesRightBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.rightBorder;
    };
    TableCellPropertiesRightBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseRightBorder;
    };
    return TableCellPropertiesRightBorderDescriptor;
}());
exports.TableCellPropertiesRightBorderDescriptor = TableCellPropertiesRightBorderDescriptor;
var TableCellPropertiesBottomBorderDescriptor = (function () {
    function TableCellPropertiesBottomBorderDescriptor() {
    }
    TableCellPropertiesBottomBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.bottomBorder = newValue;
    };
    TableCellPropertiesBottomBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.bottomBorder;
    };
    TableCellPropertiesBottomBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseBottomBorder;
    };
    return TableCellPropertiesBottomBorderDescriptor;
}());
exports.TableCellPropertiesBottomBorderDescriptor = TableCellPropertiesBottomBorderDescriptor;
var TableCellPropertiesLeftBorderDescriptor = (function () {
    function TableCellPropertiesLeftBorderDescriptor() {
    }
    TableCellPropertiesLeftBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.leftBorder = newValue;
    };
    TableCellPropertiesLeftBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.leftBorder;
    };
    TableCellPropertiesLeftBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseLeftBorder;
    };
    return TableCellPropertiesLeftBorderDescriptor;
}());
exports.TableCellPropertiesLeftBorderDescriptor = TableCellPropertiesLeftBorderDescriptor;
var TableCellPropertiesTopLeftDiagonalBorderDescriptor = (function () {
    function TableCellPropertiesTopLeftDiagonalBorderDescriptor() {
    }
    TableCellPropertiesTopLeftDiagonalBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.topLeftDiagonalBorder = newValue;
    };
    TableCellPropertiesTopLeftDiagonalBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.topLeftDiagonalBorder;
    };
    TableCellPropertiesTopLeftDiagonalBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseTopLeftDiagonalBorder;
    };
    return TableCellPropertiesTopLeftDiagonalBorderDescriptor;
}());
exports.TableCellPropertiesTopLeftDiagonalBorderDescriptor = TableCellPropertiesTopLeftDiagonalBorderDescriptor;
var TableCellPropertiesTopRightDiagonalBorderDescriptor = (function () {
    function TableCellPropertiesTopRightDiagonalBorderDescriptor() {
    }
    TableCellPropertiesTopRightDiagonalBorderDescriptor.prototype.setProp = function (props, newValue) {
        props.borders.topRightDiagonalBorder = newValue;
    };
    TableCellPropertiesTopRightDiagonalBorderDescriptor.prototype.getProp = function (props) {
        return props.borders.topRightDiagonalBorder;
    };
    TableCellPropertiesTopRightDiagonalBorderDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseTopRightDiagonalBorder;
    };
    return TableCellPropertiesTopRightDiagonalBorderDescriptor;
}());
exports.TableCellPropertiesTopRightDiagonalBorderDescriptor = TableCellPropertiesTopRightDiagonalBorderDescriptor;
var TableCellPropertiesTopMarginDescriptor = (function () {
    function TableCellPropertiesTopMarginDescriptor() {
    }
    TableCellPropertiesTopMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.top = newValue;
    };
    TableCellPropertiesTopMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.top;
    };
    TableCellPropertiesTopMarginDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseTopMargin;
    };
    return TableCellPropertiesTopMarginDescriptor;
}());
exports.TableCellPropertiesTopMarginDescriptor = TableCellPropertiesTopMarginDescriptor;
var TableCellPropertiesRightMarginDescriptor = (function () {
    function TableCellPropertiesRightMarginDescriptor() {
    }
    TableCellPropertiesRightMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.right = newValue;
    };
    TableCellPropertiesRightMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.right;
    };
    TableCellPropertiesRightMarginDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseRightMargin;
    };
    return TableCellPropertiesRightMarginDescriptor;
}());
exports.TableCellPropertiesRightMarginDescriptor = TableCellPropertiesRightMarginDescriptor;
var TableCellPropertiesBottomMarginDescriptor = (function () {
    function TableCellPropertiesBottomMarginDescriptor() {
    }
    TableCellPropertiesBottomMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.bottom = newValue;
    };
    TableCellPropertiesBottomMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.bottom;
    };
    TableCellPropertiesBottomMarginDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseBottomMargin;
    };
    return TableCellPropertiesBottomMarginDescriptor;
}());
exports.TableCellPropertiesBottomMarginDescriptor = TableCellPropertiesBottomMarginDescriptor;
var TableCellPropertiesLeftMarginDescriptor = (function () {
    function TableCellPropertiesLeftMarginDescriptor() {
    }
    TableCellPropertiesLeftMarginDescriptor.prototype.setProp = function (props, newValue) {
        props.cellMargins.left = newValue;
    };
    TableCellPropertiesLeftMarginDescriptor.prototype.getProp = function (props) {
        return props.cellMargins.left;
    };
    TableCellPropertiesLeftMarginDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseLeftMargin;
    };
    return TableCellPropertiesLeftMarginDescriptor;
}());
exports.TableCellPropertiesLeftMarginDescriptor = TableCellPropertiesLeftMarginDescriptor;
var TableCellPropertiesFitTextDescriptor = (function () {
    function TableCellPropertiesFitTextDescriptor() {
    }
    TableCellPropertiesFitTextDescriptor.prototype.setProp = function (props, newValue) {
        props.fitText = newValue;
    };
    TableCellPropertiesFitTextDescriptor.prototype.getProp = function (props) {
        return props.fitText;
    };
    TableCellPropertiesFitTextDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseFitText;
    };
    return TableCellPropertiesFitTextDescriptor;
}());
exports.TableCellPropertiesFitTextDescriptor = TableCellPropertiesFitTextDescriptor;
var TableCellPropertiesHideCellMarkDescriptor = (function () {
    function TableCellPropertiesHideCellMarkDescriptor() {
    }
    TableCellPropertiesHideCellMarkDescriptor.prototype.setProp = function (props, newValue) {
        props.hideCellMark = newValue;
    };
    TableCellPropertiesHideCellMarkDescriptor.prototype.getProp = function (props) {
        return props.hideCellMark;
    };
    TableCellPropertiesHideCellMarkDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseHideCellMark;
    };
    return TableCellPropertiesHideCellMarkDescriptor;
}());
exports.TableCellPropertiesHideCellMarkDescriptor = TableCellPropertiesHideCellMarkDescriptor;
var TableCellPropertiesNoWrapDescriptor = (function () {
    function TableCellPropertiesNoWrapDescriptor() {
    }
    TableCellPropertiesNoWrapDescriptor.prototype.setProp = function (props, newValue) {
        props.noWrap = newValue;
    };
    TableCellPropertiesNoWrapDescriptor.prototype.getProp = function (props) {
        return props.noWrap;
    };
    TableCellPropertiesNoWrapDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseNoWrap;
    };
    return TableCellPropertiesNoWrapDescriptor;
}());
exports.TableCellPropertiesNoWrapDescriptor = TableCellPropertiesNoWrapDescriptor;
var TableCellPropertiesShadingInfoDescriptor = (function () {
    function TableCellPropertiesShadingInfoDescriptor() {
    }
    TableCellPropertiesShadingInfoDescriptor.prototype.setProp = function (props, newValue) {
        props.shadingInfo = newValue;
    };
    TableCellPropertiesShadingInfoDescriptor.prototype.getProp = function (props) {
        return props.shadingInfo;
    };
    TableCellPropertiesShadingInfoDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseShadingInfoIndex;
    };
    return TableCellPropertiesShadingInfoDescriptor;
}());
exports.TableCellPropertiesShadingInfoDescriptor = TableCellPropertiesShadingInfoDescriptor;
var TableCellPropertiesTextDirectionDescriptor = (function () {
    function TableCellPropertiesTextDirectionDescriptor() {
    }
    TableCellPropertiesTextDirectionDescriptor.prototype.setProp = function (props, newValue) {
        props.textDirection = newValue;
    };
    TableCellPropertiesTextDirectionDescriptor.prototype.getProp = function (props) {
        return props.textDirection;
    };
    TableCellPropertiesTextDirectionDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseTextDirection;
    };
    return TableCellPropertiesTextDirectionDescriptor;
}());
exports.TableCellPropertiesTextDirectionDescriptor = TableCellPropertiesTextDirectionDescriptor;
var TableCellPropertiesVerticalAlignmentDescriptor = (function () {
    function TableCellPropertiesVerticalAlignmentDescriptor() {
    }
    TableCellPropertiesVerticalAlignmentDescriptor.prototype.setProp = function (props, newValue) {
        props.verticalAlignment = newValue;
    };
    TableCellPropertiesVerticalAlignmentDescriptor.prototype.getProp = function (props) {
        return props.verticalAlignment;
    };
    TableCellPropertiesVerticalAlignmentDescriptor.prototype.maskValue = function () {
        return table_cell_properties_1.TableCellPropertiesMask.UseVerticalAlignment;
    };
    return TableCellPropertiesVerticalAlignmentDescriptor;
}());
exports.TableCellPropertiesVerticalAlignmentDescriptor = TableCellPropertiesVerticalAlignmentDescriptor;
